<template>
  <div>
    <NavBar />

    <div class="container">
      <v-btn
        class="v-primary mb-1"
        @click="
          errors = [];
          $bvModal.show('create');
        "
      >
        <span class="fa fa-plus"></span> Novo
      </v-btn>

      <b-overlay :show="loading" opacity="0.99">
        <v-card>
          <v-card-title>
            Variaveis para Contrato
            <v-spacer />

            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </v-card-title>

          <v-data-table
            dense
            :headers="headers"
            :items="contract_variables"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [100, 200, 300],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.active`]="{ item }">
              {{ item.active == 1 ? "Ativo" : "Inativo" }}
            </template>
          </v-data-table>
        </v-card>
      </b-overlay>

      <ErrorsMessages :errors="errors" />

      <CreateModal
        @create="getContractVariables"
        :columnsResident="columnsResident"
        :columnsCustomer="columnsCustomer"
        :columnsRestHome="columnsRestHome"
      />

      <UpdateModal
        v-if="contract_variable"
        :contract_variable="contract_variable"
        :columnsResident="columnsResident"
        :columnsCustomer="columnsCustomer"
        :columnsRestHome="columnsRestHome"
        @update="getContractVariables"
      />
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../templates/components/ErrorsMessages";

import NavBar from "../templates/NavBar";

import api from "../services/api";

import CreateModal from "../templates/Contract/CreateModal";

import UpdateModal from "../templates/Contract/UpdateModal";

export default {
  name: "Contract",

  components: {
    NavBar,
    ErrorsMessages,
    CreateModal,
    UpdateModal,
  },

  data() {
    return {
      errors: [],

      contract_variables: [],

      columnsResident: [],

      columnsCustomer: [],

      columnsRestHome: [],

      name: "",

      search: "",

      loading: false,

      contract_variable: null,

      headers: [
        { text: "Nome da tabela", sortable: false, value: "table_name" },
        { text: "Nome da coluna", sortable: false, value: "column_name" },
        { text: "Nome da variável", sortable: false, value: "variable" },
        { text: "Descrição", sortable: false, value: "description" },
        { text: "Status", sortable: false, value: "active" },
      ],
    };
  },

  async created() {
    await this.getTables();

    await this.getContractVariables();

    this.loading = false;
  },

  methods: {
    async getContractVariables() {
      try {
        this.loading = true;

        const response = await api.get("/admin/contract/all");

        const { contract_variables } = response.data;

        this.contract_variables = contract_variables;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async getTables() {
      try {
        this.loading = true;

        const response = await api.get("/admin/contract/columns-table");

        const { columnsResident, columnsCustomer, columnsRestHome } =
          response.data;

        this.columnsResident = columnsResident;

        this.columnsCustomer = columnsCustomer;

        this.columnsRestHome = columnsRestHome;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    handleClickRowTable(item) {
      this.contract_variable = item;
      this.$bvModal.show("update");
    },
  },
};
</script>